"use client";

import { LogOut } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/components/AuthProvider";

export default function LogoutButton({
  children = null,
  className = "",
  mobile = false,
  onBeforeLogout = null,
  onAfterLogout = null,
  onSuccess = null,
}) {
  const { logout } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleClick(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    event?.nativeEvent?.stopImmediatePropagation?.();

    if (isSubmitting) return;
    setIsSubmitting(true);
    onBeforeLogout?.();
    const afterLogout = onAfterLogout || onSuccess;
    requestAnimationFrame(() => afterLogout?.());
    try {
      await logout();
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Logout failed", err);
      }
      setIsSubmitting(false);
      return;
    }
  }

  if (mobile) {
    return (
      <button
        onClick={handleClick}
        type="button"
        disabled={isSubmitting}
        className={`mb-10 flex w-full items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-3 text-sm font-semibold text-gray-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 active:bg-gray-300 ${
          isSubmitting ? "cursor-not-allowed opacity-60" : "hover:bg-gray-200"
        }`}
      >
        {isSubmitting ? (
          "Logging out..."
        ) : (
          <>
            <LogOut className="h-4 w-4" aria-hidden="true" />
            Logout
          </>
        )}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isSubmitting}
      className={`${className} ${isSubmitting ? "opacity-60 cursor-not-allowed" : ""}`}
    >
      {isSubmitting ? "Logging out..." : children}
    </button>
  );
}
